import Vue, { PropType } from 'vue'
import { AppliedVoucher } from '~models/appliedVoucher'
import { Redemption } from '~models/redemption'
import axios from '~plugins/axios'

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    voucher: {
      type: Object as PropType<AppliedVoucher>,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      errors: [],
    }
  },
  computed: {
    redemption(): Redemption {
      return this.$store.state.redemptions.redemption
    },
  },
  methods: {
    async deleteVoucher() {
      try {
        this.loading = true
        await axios.delete(`/redemptions/${this.redemption.id}/voucher/${this.voucher.id}`)
        const { data } = await axios.get(`/redemptions/${this.redemption.id}`)
        this.$store.dispatch('redemptions/setRedemption', data)
        this.$emit('input', false)
      } catch (error) {
        if (!axios.isAxiosError(error)) {
          throw error
        }

        if (!error.response) {
          throw error
        }

        if (Array.isArray(error.response.data.errors)) {
          this.errors = error.response.data.errors
        }
      } finally {
        this.loading = false
      }
    },
  },
})
